import { Routes } from '@angular/router';
import { Splash } from './auth/splash/splash';
import { authGuard } from './guards/auth.guard';
import { promoStatusGuard } from './guards/promo-status.guard';
import { noAuthGuard } from './guards/no-auth.guard';
import { AppLayout } from './layouts/app-layout/app-layout';
import { GameLayout } from './layouts/game-layout/game-layout';
import { PromoNotActiveComponent } from './play/not-active/promo-not-active';
import { Login } from './auth/login/login';
import { SignupComponent } from './auth/signup/signup';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password';
import { ResetPasswordComponent } from './auth/reset-password/reset-password';

export const routes: Routes = [

  // Promo not active route
  {
    path: 'promo-not-active',
    component: PromoNotActiveComponent
  },

  // Splash (nav title is Home)
  {
    path: '',
    component: AppLayout,
    canActivate: [promoStatusGuard],
    canActivateChild: [promoStatusGuard],
    children: [
      { path: '', component: Splash }
    ]
  },
    
  // Authentication routes (in app layout, no auth guard)
  {
    path: 'auth',
    component: AppLayout,
    canActivateChild: [promoStatusGuard, noAuthGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: Login },
      { path: 'signup', component: SignupComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent }
    ]
  },
  
  // App layout routes (with navigation and footer)
  {
    path: 'app',
    component: AppLayout,
    canActivateChild: [promoStatusGuard, authGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', loadComponent: () => import('./play/home/home').then(m => m.Home) },
      { path: 'myavatar', loadComponent: () => import('./play/myavatar/myavatar').then(m => m.Myavatar) },
      { path: 'myprizes', loadComponent: () => import('./play/myprizes/myprizes').then(m => m.Myprizes) }
    ]
  },

  // Game layout routes (full screen, no navigation)
  {
    path: 'game',
    component: GameLayout,
    canActivate: [promoStatusGuard, authGuard],
    children: [
      { path: '', redirectTo: 'play', pathMatch: 'full' },
      { 
        path: 'play', 
        loadComponent: () => import('./play/game/game').then(m => m.Game)
      }
    ]
  },
  
  // Wildcard promo status guard
  { 
    path: '**', 
    redirectTo: '/',
    pathMatch: 'full'
  }
];
